'use strict'

import { GENERAL_PARAMETERS_URL_LOGO } from '../store/mutations-types'
/**
 * Archivo con metodo para setear colores primarios y el icono de la obra.
 *
 * @author Andres Correa
 * @since 28/08/2020 08:40 AM
 * @version 1.0.0
 */

const generalParametersMixin = {
  methods: {
    /**
     * Este método cambia lo siguiente: color primario, secundario y imagen de la obra
     *
     * @author Andres Correa
     * @since  28/08/2020 08:40 AM
     * @version 1.0.0
     */
    $_generalParametersMixin_update (colorPrincipal, colorSecundario, logo) {
      this.$vuetify.theme.themes.light.primary = colorPrincipal
      this.$vuetify.theme.themes.light.secondary = colorSecundario
      this.$store.commit(GENERAL_PARAMETERS_URL_LOGO, logo)
    }
  }
}

export default generalParametersMixin
